// tslint:disable:no-http-string
import { withPrefix } from 'gatsby';
import * as React from 'react';
import { css } from '@emotion/core';

const SiteNavLogoStyles = css`
  flex-shrink: 0;
  display: block;
  margin-right: 24px;
  margin-left: 3px;
  line-height: 1em;
  transition: transform 0.2s cubic-bezier(0, 1.8, 1, 1.8);

  img {
    display: block;
    height: 38px;
    width: auto;
  }

  @media (max-width: 640px) {
    img {
      height: 32px;
    }
  }
`;

const SiteNavLogo = () => (
  <a className="site-nav-logo" css={SiteNavLogoStyles} href="https://giggster.com" title="Go to Giggster">
    <picture>
      <source
        srcSet={withPrefix('/assets/icons/logo-small.svg')}
        media="(max-width: 640px)"
        width={32}
        height={32}
      />
      <img
        src={withPrefix('/assets/icons/logo.svg')}
        alt="Giggster logo"
        width={144}
        height={38}
      />
    </picture>
  </a>
);

export default SiteNavLogo;
